// hooks/useKycSession.js
import { useState, useRef, useCallback } from "react";
import axios from "axios";
// Se não estiver usando Enviroments aqui, pode remover a import
// import Enviroments from "../enviroments/enviroments";

const useKycSession = () => {
  // Tenta reaproveitar sessão salva no localStorage
  const [frameId, setFrameId] = useState(() => {
    return localStorage.getItem("kyc_frame_id") || null;
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Evita múltiplas chamadas simultâneas
  const hasRequestedRef = useRef(false);

  const fetchKycSession = useCallback(
    async () => {
      // Se já temos frameId, não faz nova request
      if (frameId) {
        return frameId;
      }

      // Se já tem request em andamento, só retorna o valor atual
      if (loading || hasRequestedRef.current) {
        return frameId;
      }

      hasRequestedRef.current = true;
      setLoading(true);
      setError(null);

      try {
        const cpf = localStorage.getItem("cpf");

        const token = "acbb65eb-3aaa-4933-be30-4e92f07cbec6";
        const flow = "kyc-faceindex";
        const betHouse = "lotogreen";

        const authToken = localStorage.getItem("apiToken");
        if (!authToken) {
          throw new Error("Token de autenticação não encontrado no localStorage.");
        }

        const response = await axios.post(
          "https://api-aviator-new-e377b0de89f5.herokuapp.com/kyc/session",
          {
            cpf,
            token,
            flow,
            betHouse,
          },
          {
            headers: {
              Authorization: `Bearer ${authToken}`,
            },
          }
        );

        const sessionId = response?.data?.session_id;

        if (sessionId) {
          setFrameId(sessionId);
          localStorage.setItem("kyc_frame_id", sessionId);
          return sessionId;
        } else {
          const msg = "Não foi possível obter o ID da sessão KYC";
          setError(msg);
          hasRequestedRef.current = false; // libera para tentar de novo depois
          throw new Error(msg);
        }
      } catch (err) {
        const msg =
          err?.response?.data?.message || err.message || "Erro ao obter sessão KYC";
        setError(msg);
        console.error("Erro ao obter sessão KYC:", err);
        hasRequestedRef.current = false; // libera retry
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [frameId, loading]
  );

  // Se em algum fluxo você quiser forçar criar uma nova sessão KYC:
  const resetKycSession = useCallback(() => {
    hasRequestedRef.current = false;
    setFrameId(null);
    localStorage.removeItem("kyc_frame_id");
    setError(null);
  }, []);

  return {
    frameId,
    loading,
    error,
    fetchKycSession,
    resetKycSession,
  };
};

export default useKycSession;
